
import { defineComponent } from 'vue';
import BottomNav from '@/components/BottomNav.vue';
import { HeapPagePathReges } from '@/router';

export default defineComponent({
  components: {
    BottomNav,
  },
  computed: {
    isBottomNavVisible() {
      const { path } = this.$route;
      return HeapPagePathReges.reduce((pv, reg) => pv || reg.test(path), false);
    },
  },
});
